// message-bar.service.ts

import { Injectable, signal } from '@angular/core';

export interface SiteMessage {
  id: string;
  type?: 'info' | 'warning' | 'error' | 'success';
  title?: string;
  message: string;

  ctaLabel?: string;
  ctaAction?: () => void;

  dismissible?: boolean;

  /**
   * Auto dismiss after ms
   */
  duration?: number;

  /**
   * Persist dismissal in localStorage
   */
  persistDismissal?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MessageBarService {
  private readonly STORAGE_KEY = 'dismissed-site-messages';

  messages = signal<SiteMessage[]>([]);

  private dismissedIds = new Set<string>(
    JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]')
  );

  show(message: SiteMessage) {
    const currentMessages = this.messages();
    if (
      (message.persistDismissal && this.dismissedIds.has(message.id))
      || currentMessages.find((m) => m.id === message.id)
    ) {
      return;
    }
    this.messages.update((msgs) => [...msgs, message]);

    if (message.duration) {
      setTimeout(() => {
        this.dismiss(message.id);
      }, message.duration);
    }
  }

  dismiss(id: string) {
    const message = this.messages().find((m) => m.id === id);

    if (message?.persistDismissal) {
      this.dismissedIds.add(id);

      localStorage.setItem(
        this.STORAGE_KEY,
        JSON.stringify([...this.dismissedIds])
      );
    }

    this.messages.update((msgs) =>
      msgs.filter((m) => m.id !== id)
    );
  }

  clear() {
    this.messages.set([]);
  }
}